import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Select, { SelectProps } from "@insite/mobius/Select";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

export interface StylesYmmeDropdown {
    value?: string;
    dropdownData?: any;
    active?: boolean;
    onValueChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    extendedStyles?: YmmeDropdownStyles;
    selectLabel?: string;
}

export interface YmmeDropdownStyles {
    dropdownSelect?: SelectProps;
    container?: InjectableCss;
}

export const ymmeDropdownStyles: YmmeDropdownStyles = {
    dropdownSelect: {},
    container: {},
};

const StoreYmmeDropdown: React.FC<StylesYmmeDropdown> = ({
    value,
    onValueChange,
    extendedStyles,
    dropdownData,
    active,
    selectLabel,
}) => {
    const label = selectLabel || "---";
    const [styles] = React.useState(() => mergeToNew(ymmeDropdownStyles, extendedStyles));
    let dropdownDataList: string[] = dropdownData.list;
    if (!dropdownDataList) {
        dropdownDataList = [];
    }
    return (
        <StyledWrapper {...styles.container}>
            {dropdownDataList?.length > 0 ? (
                <Select
                    {...styles.dropdownSelect}
                    value={dropdownData.selection}
                    onChange={onValueChange}
                    disabled={active}
                    uid={`${label}dropdown`}
                >
                    <option value="">{label}</option>
                    {dropdownDataList.map(item => (
                        <option key={item} value={item}>
                            {item}
                        </option>
                    ))}
                </Select>
            ) : (
                <Select {...styles.dropdownSelect} disabled value={value} uid={`${label}dropdowndisabled`}>
                    <option value="">{label}</option>
                </Select>
            )}
        </StyledWrapper>
    );
};

export default StoreYmmeDropdown;
